module.exports = __webpack_public_path__ + "img/prata.506f6bd2.png";